var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ReportsListingWidget = /** @class */ (function () {
    function ReportsListingWidget(widgetId) {
        this.reportsList = null;
        this.loadMoreBtn = null;
        this.loadingEl = null;
        this.noResultsEl = null;
        this.reportsCounter = null;
        this.reportsCountSpan = null;
        this.postsPerPage = 2;
        this.currentPage = 1;
        this.currentFilters = {
            keyword: '',
            topics: [],
            years: []
        };
        this.isLoading = false;
        this.currentRequestId = 0;
        this.abortController = null;
        this.widgetId = widgetId;
        this.container = document.querySelector("[data-widget-id=\"".concat(widgetId, "\"]"));
        if (!this.container) {
            console.error("Reports Listing Widget: Container not found for widget ID ".concat(widgetId));
            return;
        }
        this.reportsList = this.container.querySelector('.rmff-reports-list');
        this.loadMoreBtn = this.container.querySelector('.rmff-load-more-btn');
        this.loadingEl = this.container.querySelector('.rmff-reports-loading');
        this.noResultsEl = this.container.querySelector('.rmff-no-results');
        this.reportsCounter = this.container.querySelector('.rmff-reports-counter');
        this.reportsCountSpan = this.container.querySelector('.rmff-reports-count');
        this.postsPerPage = parseInt(this.container.getAttribute('data-posts-per-page') || '2');
        this.init();
    }
    ReportsListingWidget.prototype.init = function () {
        this.bindEvents();
        this.initializeFiltersFromURL();
        this.bindHistoryEvents();
        this.loadInitialReports();
    };
    ReportsListingWidget.prototype.bindEvents = function () {
        var _this = this;
        // Load more button
        if (this.loadMoreBtn) {
            this.loadMoreBtn.addEventListener('click', function () {
                _this.loadMoreReports();
            });
        }
        // Listen for filter events from the filters widget
        document.addEventListener('rmff-reports-filtered', function (event) {
            var customEvent = event;
            if (customEvent.detail && customEvent.detail.filters) {
                _this.handleFilterChange(customEvent.detail.filters);
            }
        });
        // Listen for filter clear events
        document.addEventListener('rmff-filters-cleared', function (event) {
            var customEvent = event;
            if (customEvent.detail && customEvent.detail.widgetId !== _this.widgetId) {
                _this.handleFilterClear();
            }
        });
    };
    /**
     * Initialize listing filters from URL parameters, to match filters widget behavior on load/back
     */
    ReportsListingWidget.prototype.initializeFiltersFromURL = function () {
        var urlParams = new URLSearchParams(window.location.search);
        var topicsParam = urlParams.get('topics') || '';
        var yearsParam = urlParams.get('years') || '';
        var keywordsParam = urlParams.get('keywords') || '';
        var topics = topicsParam ? topicsParam.split(',').map(function (t) { return t.trim(); }).filter(Boolean) : [];
        var years = yearsParam ? yearsParam.split(',').map(function (y) { return y.trim(); }).filter(Boolean) : [];
        var keyword = keywordsParam || '';
        this.currentFilters = {
            keyword: keyword,
            topics: topics,
            years: years,
        };
    };
    /**
     * Reapply filters when navigating with back/forward (popstate/pageshow)
     */
    ReportsListingWidget.prototype.bindHistoryEvents = function () {
        var _this = this;
        var reapplyFromURL = function () {
            _this.initializeFiltersFromURL();
            _this.currentPage = 1;
            _this.loadReports(true);
        };
        window.addEventListener('popstate', reapplyFromURL);
        window.addEventListener('pageshow', function (event) {
            var e = event;
            if (!e || e.persisted === true || e.persisted === false) {
                reapplyFromURL();
            }
        });
    };
    ReportsListingWidget.prototype.handleFilterChange = function (filters) {
        this.currentFilters = __assign({}, filters);
        this.currentPage = 1;
        // If all filters are empty (cleared), do a full reset
        var isClearing = !filters.keyword &&
            (!filters.topics || filters.topics.length === 0) &&
            (!filters.years || filters.years.length === 0);
        if (isClearing) {
            // Reset posts per page to original value from DOM (in case it was corrupted)
            this.postsPerPage = parseInt(this.container.getAttribute('data-posts-per-page') || '2');
            // Clear URL parameters to ensure clean state
            var url = new URL(window.location.href);
            url.searchParams.delete('topics');
            url.searchParams.delete('years');
            url.searchParams.delete('keywords');
            url.searchParams.delete('paged');
            url.searchParams.delete('page');
            url.searchParams.delete('posts_per_page');
            // Update URL without triggering popstate
            window.history.replaceState({}, '', url.toString());
        }
        this.loadReports(true);
    };
    ReportsListingWidget.prototype.handleFilterClear = function () {
        // Reset all filters
        this.currentFilters = {
            keyword: '',
            topics: [],
            years: []
        };
        // Reset pagination
        this.currentPage = 1;
        // Reset posts per page to original value from DOM (in case it was corrupted)
        this.postsPerPage = parseInt(this.container.getAttribute('data-posts-per-page') || '2');
        // Clear URL parameters to ensure clean state
        var url = new URL(window.location.href);
        url.searchParams.delete('topics');
        url.searchParams.delete('years');
        url.searchParams.delete('keywords');
        url.searchParams.delete('paged');
        url.searchParams.delete('page');
        url.searchParams.delete('posts_per_page');
        // Update URL without triggering popstate
        window.history.replaceState({}, '', url.toString());
        // Load reports with fresh state
        this.loadReports(true);
    };
    ReportsListingWidget.prototype.loadInitialReports = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadReports(true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportsListingWidget.prototype.loadMoreReports = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoading)
                            return [2 /*return*/];
                        this.currentPage++;
                        return [4 /*yield*/, this.loadReports(false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportsListingWidget.prototype.loadReports = function () {
        return __awaiter(this, arguments, void 0, function (replace) {
            var requestId, response, error_1;
            if (replace === void 0) { replace = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Cancel any pending request
                        if (this.abortController) {
                            this.abortController.abort();
                        }
                        // Create new abort controller for this request
                        this.abortController = new AbortController();
                        // Generate unique request ID
                        this.currentRequestId++;
                        requestId = this.currentRequestId;
                        this.isLoading = true;
                        this.showLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.fetchReports(this.abortController.signal)];
                    case 2:
                        response = _a.sent();
                        // Check if this is still the most recent request
                        if (requestId !== this.currentRequestId) {
                            return [2 /*return*/];
                        }
                        if (response.success) {
                            this.renderReports(response.data.reports, replace);
                            this.updateLoadMoreButton(response.data.has_more);
                            this.toggleNoResults(response.data.reports.length === 0 && replace);
                            this.updateReportsCounter(response.data.total_found);
                        }
                        else {
                            console.error('Failed to load reports:', response);
                            this.showError('Failed to load reports. Please try again.');
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        // Ignore abort errors
                        if (error_1.name === 'AbortError') {
                            return [2 /*return*/];
                        }
                        console.error('Error loading reports:', error_1);
                        this.showError('An error occurred while loading reports.');
                        return [3 /*break*/, 5];
                    case 4:
                        // Only reset loading state if this is still the current request
                        if (requestId === this.currentRequestId) {
                            this.isLoading = false;
                            this.hideLoading();
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ReportsListingWidget.prototype.fetchReports = function (signal) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, response;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('action', 'get_filtered_reports');
                        formData.append('nonce', ((_a = window.rmff_ajax) === null || _a === void 0 ? void 0 : _a.nonce) || '');
                        formData.append('page', this.currentPage.toString());
                        formData.append('posts_per_page', this.postsPerPage.toString());
                        formData.append('keyword', this.currentFilters.keyword || '');
                        formData.append('topics', JSON.stringify(this.currentFilters.topics));
                        formData.append('years', JSON.stringify(this.currentFilters.years));
                        return [4 /*yield*/, fetch(((_b = window.rmff_ajax) === null || _b === void 0 ? void 0 : _b.ajax_url) || '/wp-admin/admin-ajax.php', {
                                method: 'POST',
                                body: formData,
                                signal: signal
                            })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    ReportsListingWidget.prototype.renderReports = function (reports, replace) {
        var _this = this;
        if (replace === void 0) { replace = false; }
        if (!this.reportsList)
            return;
        if (replace) {
            this.reportsList.innerHTML = '';
        }
        reports.forEach(function (report) {
            var reportCard = _this.createReportCard(report);
            _this.reportsList.appendChild(reportCard);
        });
    };
    ReportsListingWidget.prototype.createReportCard = function (report) {
        var _a;
        var card = document.createElement('div');
        card.className = 'rmff-report-card';
        card.setAttribute('data-report-id', report.id.toString());
        var themeUrl = ((_a = window.rmff_ajax) === null || _a === void 0 ? void 0 : _a.theme_url) || '';
        var fallbackImageUrl = themeUrl ? "".concat(themeUrl, "/assets/images/report-cover.png") : '/wp-content/themes/rmff2025/assets/images/report-cover.png';
        var imageHtml = report.featured_image
            ? "<div class=\"rmff-report-image\">\n                 <img src=\"".concat(report.featured_image.url, "\" alt=\"").concat(report.featured_image.alt, "\" loading=\"lazy\">\n               </div>")
            : "<div class=\"rmff-report-image\">\n                 <img src=\"".concat(fallbackImageUrl, "\" alt=\"Report cover\" loading=\"lazy\">\n               </div>");
        var topicsHtml = report.topics.length > 0
            ? "<div class=\"rmff-report-topics\">\n                 <svg class=\"rmff-report-topics-icon\" width=\"17\" height=\"25\" viewBox=\"0 0 17 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                     <mask id=\"mask0_1976_1698\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"17\" height=\"25\">\n                         <rect x=\"0.469971\" width=\"16\" height=\"25\" fill=\"#D9D9D9\"/>\n                     </mask>\n                     <g mask=\"url(#mask0_1976_1698)\">\n                         <path d=\"M13.375 4H6.33333C5.43958 4 4.70833 4.73125 4.70833 5.625V7.25H2V15.1042C2 16.1496 2.85042 17 3.89583 17H13.1042C14.1496 17 15 16.1496 15 15.1042V5.625C15 4.73125 14.2688 4 13.375 4ZM4.70833 15.1042C4.70833 15.5538 4.34542 15.9167 3.89583 15.9167C3.44625 15.9167 3.08333 15.5538 3.08333 15.1042V8.33333H4.70833V15.1042ZM13.9167 15.1042C13.9167 15.5538 13.5538 15.9167 13.1042 15.9167H5.6075C5.72667 15.6729 5.79167 15.3967 5.79167 15.1042V5.625C5.79167 5.32708 6.03542 5.08333 6.33333 5.08333H13.375C13.6729 5.08333 13.9167 5.32708 13.9167 5.625V15.1042ZM10.125 7.25H12.8333V8.33333H10.125V7.25ZM6.875 9.41667H12.8333V10.5H6.875V9.41667ZM6.875 11.5833H12.8333V12.6667H6.875V11.5833ZM6.875 13.75H12.8333V14.8333H6.875V13.75ZM9.04167 8.33333H6.875V6.16667H9.04167V8.33333Z\" fill=\"#6B7173\"/>\n                     </g>\n                 </svg>\n                 ".concat(report.topics.map(function (topic, index) {
                var isLast = index === report.topics.length - 1;
                var label = "".concat(topic.name).concat(isLast ? '' : ',');
                return "<a href=\"".concat(topic.link, "\" class=\"rmff-report-topic\">").concat(label, "</a>");
            }).join(' '), "\n               </div>")
            : '';
        var dateFormatted = this.formatDate(report.date);
        card.innerHTML = "\n            ".concat(imageHtml, "\n            <div class=\"rmff-report-content\">\n                <h3 class=\"rmff-report-title\">\n                    <a href=\"").concat(report.permalink, "\">").concat(report.title, "</a>\n                </h3>\n                <div class=\"rmff-report-meta\">\n                    <span class=\"rmff-report-date\">\n                        <svg class=\"rmff-report-date-icon\" width=\"17\" height=\"25\" viewBox=\"0 0 17 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                            <mask id=\"mask0_1976_1686\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"17\" height=\"25\">\n                                <rect x=\"0.469971\" width=\"16\" height=\"25\" fill=\"#D9D9D9\"/>\n                            </mask>\n                            <g mask=\"url(#mask0_1976_1686)\">\n                                <path d=\"M13.72 5.16676H11.97V4H10.8032V5.16676H6.13646V4H4.9697V5.16676H3.2197C2.25337 5.16676 1.46997 5.95016 1.46997 6.91676V18H15.47V6.91676C15.47 5.95016 14.6866 5.16676 13.72 5.16676ZM2.63673 6.91676C2.63673 6.59465 2.89786 6.33352 3.21997 6.33352H13.72C14.0421 6.33352 14.3032 6.59465 14.3032 6.91676V8.66676H2.63673V6.91676ZM2.63673 16.8332V9.83324H14.3035V16.8332H2.63673Z\" fill=\"#6B7173\"/>\n                                <path d=\"M11.3867 11.5832H10.22V12.7499H11.3867V11.5832Z\" fill=\"#6B7173\"/>\n                                <path d=\"M9.05354 11.5832H7.88678V12.7499H9.05354V11.5832Z\" fill=\"#6B7173\"/>\n                                <path d=\"M6.71992 11.5832H5.55316V12.7499H6.71992V11.5832Z\" fill=\"#6B7173\"/>\n                                <path d=\"M11.3867 13.9168H10.22V15.0836H11.3867V13.9168Z\" fill=\"#6B7173\"/>\n                                <path d=\"M9.05354 13.9168H7.88678V15.0836H9.05354V13.9168Z\" fill=\"#6B7173\"/>\n                                <path d=\"M6.71992 13.9168H5.55316V15.0836H6.71992V13.9168Z\" fill=\"#6B7173\"/>\n                            </g>\n                        </svg>\n                        ").concat(dateFormatted, "\n                    </span>\n                    ").concat(topicsHtml, "\n                </div>\n                <p class=\"rmff-report-excerpt\">").concat(report.excerpt, "</p>\n            </div>\n        ");
        return card;
    };
    ReportsListingWidget.prototype.formatDate = function (dateString) {
        var date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long'
        });
    };
    ReportsListingWidget.prototype.updateLoadMoreButton = function (hasMore) {
        if (this.loadMoreBtn) {
            var container = this.loadMoreBtn.closest('.rmff-load-more-container');
            if (container) {
                container.style.display = hasMore ? 'block' : 'none';
            }
        }
    };
    ReportsListingWidget.prototype.toggleNoResults = function (show) {
        if (this.noResultsEl) {
            this.noResultsEl.style.display = show ? 'block' : 'none';
        }
    };
    ReportsListingWidget.prototype.showLoading = function () {
        if (this.loadingEl) {
            this.loadingEl.style.display = 'block';
        }
        if (this.loadMoreBtn) {
            this.loadMoreBtn.disabled = true;
        }
    };
    ReportsListingWidget.prototype.hideLoading = function () {
        if (this.loadingEl) {
            this.loadingEl.style.display = 'none';
        }
        if (this.loadMoreBtn) {
            this.loadMoreBtn.disabled = false;
        }
    };
    ReportsListingWidget.prototype.showError = function (message) {
        if (this.reportsList) {
            this.reportsList.innerHTML = "\n                <div class=\"rmff-error\" style=\"text-align: center; padding: 2rem; color: #dc2626;\">\n                    <p>".concat(message, "</p>\n                </div>\n            ");
        }
    };
    ReportsListingWidget.prototype.updateReportsCounter = function (totalFound) {
        if (!this.reportsCounter || !this.reportsCountSpan)
            return;
        this.reportsCountSpan.textContent = totalFound.toString();
        this.reportsCounter.style.display = 'block';
    };
    return ReportsListingWidget;
}());
// Export function for main index.ts
export function initReportsListingWidgets() {
    var listingWidgets = document.querySelectorAll('.rmff-reports-listing-widget');
    listingWidgets.forEach(function (widget) {
        var widgetId = widget.getAttribute('data-widget-id');
        if (widgetId) {
            new ReportsListingWidget(widgetId);
        }
    });
}
// Export for external use
window.ReportsListingWidget = ReportsListingWidget;
